import React, { useState } from "react";
import SingleLineJob from "./customComponents/SingleLineJob";
import ContactUsModal from "./ContactUsModal";

const data = [
  {
    id: 0,
    title: '1. Practical experience :',
    subtitle: 'Students will gain practical, hands-on experience that is directly applicable to their future careers.'
  },
  {
    id: 1,
    title: '2. Problem-solving skills :',
    subtitle: '​Through our program, students will develop critical thinking and problem-solving skills that will help them succeed in their future careers.'
  },
  {
    id: 2,
    title: '3. Networking opportunities :',
    subtitle: 'Our program offers students the opportunity to network with industry experts and community partners, building valuable connections for their future careers.'
  },
  {
    id: 3,
    title: '4. Personal growth :',
    subtitle: 'Through our program, students will develop their interpersonal skills, teamwork abilities, and leadership capabilities, all of which are essential for success in any career.'
  },
  {
    id: 4,
    title: '5. Resume building :',
    subtitle: `Participating in an applied learning project is a valuable addition to any student's resume, demonstrating their commitment to experiential learning and problem-solving.`
  }
]

const learningData = [
  { contentTxt: 'Comprehensive knowledge' },
  { contentTxt: 'Hands-on experience' },
  { contentTxt: 'In-demand skills' },
  { contentTxt: 'Creative Freedom' },
  { contentTxt: 'Flexibility' },
  { contentTxt: 'Community' }
]

const AppliedLearningProject = () => {
  const [closeModal, setCloseModal] = useState(false);

  const toggleModal=()=> {
    setCloseModal(!closeModal)
  }
  
  return (
    <>
      <div className="container px-2 py-3 py-md-5 d-flex flex-column align-items-center">
        <div className="headerText text-center  pb-3 pb-md-5">Applied Learning Project</div>
        <div className="text-center px-3" style={{ color: '#8F8E8E', font: '400 clamp(1rem, 2.5vw, 2rem)/normal Nunito' }}>What is an applied learning project? It's a project-based learning experience that allows students to take an active role in solving real-world problems. Through our program, students will work closely with faculty, industry experts, and community partners to identify a problem or challenge, develop a plan of action, and implement a solution.
        </div>
        <div className="text-center py-3" style={{ color: '#FF6D28', font: '700 clamp(1.5rem, 2.5vw, 2.5rem)/normal Nunito', letterSpacing: '0.18px' }}>
          Our program offers a range of benefits for students, including :
        </div>
        <div className="d-flex flex-column py-3" style={{ gap: 'clamp(1rem, 2.5vw, 2rem)' }}>
          {data.map((item) => (
            <div key={item.id} className="d-flex flex-column px-3" style={{ gap: 'clamp(0.5rem, 1.5vw, 1rem)' }}>
              <p style={{ color: '#000', font: '700 clamp(1.2rem, 2.5vw, 2rem)/normal Nunito' }}>{item.title}</p>
              <span style={{ color: '#8F8E8E', font: '400 clamp(1rem, 2.5vw, 2rem)/normal Nunito' }}>{item.subtitle}</span>
            </div>
          ))}
        </div>
      </div>
      <div className='mb-3 mb-md-5 w-100' style={{ backgroundColor: '#F5F5FF' }}>
        <div className="container py-3 py-md-5 px-2 px-md-5 d-flex flex-column align-items-center">
          <span className="text-center" style={{ color: '#8F8E8E', font: '400 clamp(1rem, 2.5vw, 1.5rem)/normal Nunito' }}>
            Our program is open to all students, regardless of major or background. We believe that everyone can benefit from the practical, hands-on learning experience that our program provides.
            <br />
            So, if you're ready to take your learning to the next level and gain practical, real-world experience, we encourage you to apply for our applied learning project program. We look forward to working with you and helping you achieve your career goals!</span>
        </div>
      </div>
      <div className="container px-2 py-3 py-md-5 d-flex flex-column align-items-center">
        <div className="headerText text-center  pb-3 pb-md-5">Start Learning Today</div>
        <div className="row align-items-center justify-content-center" style={{gap: 'clamp(1rem, 2.5vw, 2rem)'}}>
        {learningData.map((item) => (
            <SingleLineJob item={item} tickMark={true} />
        ))}
      </div>
      </div>
      <div className="w-100 d-flex flex-column align-items-center justify-content-center pt-2 pb-3 pb-md-5" style={{ gap: 'clamp(0.5rem, 2.5vw, 1rem)' }}>
        <button className="enroll_now_button" onClick={toggleModal}>Enroll Now</button>
        <span style={{color: '#020202', font: '800 clamp(1rem, 2.5vw, 1.5rem)/normal Nunito', letterSpacing: '0.12px'}}>Starts from 23 November</span>
      </div>
      {closeModal && <ContactUsModal closeModal={closeModal} toggleModal={toggleModal} />}
    </>
  );
};

export default AppliedLearningProject;
